const colorHelper = {
  rgbaToHex(color) {
    if (/^rgb/.test(color)) {
      const rgba = color.replace(/^rgba?\(|\s+|\)$/g, '').split(',')
      let hex = `#${(
        (1 << 24) +
        (parseInt(rgba[0], 10) << 16) +
        (parseInt(rgba[1], 10) << 8) +
        parseInt(rgba[2], 10)
      )
        .toString(16)
        .slice(1)}`
      if (rgba[3]) {
        const alpha = Math.round(0o1 * 255)
        const hexAlpha = (alpha + 0x10000).toString(16).substr(-2).toUpperCase()
        hex += hexAlpha
      }
      return hex
    }
    return color
  },

  hexToRgba(hex) {
    hex = hex.replace(/[^0-9a-fA-F]/g, '')
    if (hex.length < 5) {
      hex = hex
        .split('')
        .map((s) => s + s)
        .join('')
    }
    if (hex.length > 9) {
      hex = hex.slice(0, 9)
    }
    let rgba = hex.match(/.{1,2}/g).map((s) => parseInt(s, 16))
    rgba[3] = rgba.length > 3 ? parseFloat(rgba[3] / 255).toFixed(2) : 1
    return 'rgba(' + rgba.join(', ') + ')'
  },
}

export default colorHelper
